import { HandleClientError } from './client-error-service';

class ConfigurationService {
	private static _instance: ConfigurationService;
	gridMultiValuePropertyDelimiter: string;

	public static get Instance() {
		return this._instance || (this._instance = new this());
	}

	public async Initialize(): Promise<void> {
		this.gridMultiValuePropertyDelimiter =
			sessionStorage.getItem('gridMultiValuePropertyDelimiter') ??
			(await fetch(`/clientData/mvpDelimiter`)
				.then((res) => res.json())
				.catch((e) => HandleClientError('gridMultiValuePropertyDelimiter', e)));

		sessionStorage.setItem('gridMultiValuePropertyDelimiter', this.gridMultiValuePropertyDelimiter);
	}
}

const configuration = ConfigurationService.Instance;

export default configuration;
